import { render, staticRenderFns } from "./ScopeOfPracticeInformation.vue?vue&type=template&id=852d25fc&scoped=true&"
import script from "./ScopeOfPracticeInformation.vue?vue&type=script&lang=js&"
export * from "./ScopeOfPracticeInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852d25fc",
  null
  
)

export default component.exports